import { IHttpService } from "../HttpService";
import ValueListLabel, {
  IValueListLabel
} from "../../model/valuelist/ValueListLabel";
import ValueListItem, {
  IValueListItem
} from "../../model/valuelist/ValueListItem";

export interface IValueListService {
  getValueListLabels(): Promise<IValueListLabel[]>;
  getValueList(label: string): Promise<IValueListItem[]>;
  updateValue(valueListItem: IValueListItem): Promise<any>;
  createValue(valueListItem: IValueListItem): Promise<any>;
  deleteValueList(label: string): Promise<any>;
  deleteValue(valueListItemId: number): Promise<any>;
}

const ValueListService = (httpService): IValueListService => {
  const _http: IHttpService = httpService;
  const _basePath: string = "/api/";
  const _valueListPath = "value-list";
  const _labelsPath = "labels";

  const ValueListLabelMapper = (json: any = []) => {
    return json.map((item: any) => ValueListLabel(item));
  };

  const ValueListItemMapper = (json: any = []) => {
    return json.map((item: any) => ValueListItem(item));
  };

  const ValueListEditableParamsMapper = (valueListItem: IValueListItem) => {
    return {
      id: valueListItem.id,
      code: valueListItem.code,
      value: valueListItem.value
    };
  };

  const ValueListParamsMapper = (valueListItem: IValueListItem) => {
    return {
      code: valueListItem.code,
      label: valueListItem.label,
      value: valueListItem.value
    };
  };

  return {
    async getValueListLabels() {
      const path = _http.buildPath(_basePath, _valueListPath, _labelsPath);
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return ValueListLabelMapper(responseJSON);
    },

    async getValueList(label: string) {
      const path = _http.buildPath(
        _basePath,
        _valueListPath,
        _labelsPath,
        label
      );
      const response = await _http.get(path);
      const responseJSON = await _http.toJSON(response);
      return ValueListItemMapper(responseJSON);
    },

    async updateValue(valueListItem: IValueListItem) {
      const path = _http.buildPath(
        _basePath,
        _valueListPath,
        valueListItem.id.toString()
      );
      const response = await _http.put(path, {
        params: ValueListEditableParamsMapper(valueListItem)
      });
      return _http.toText(response);
    },

    async createValue(valueListItem: IValueListItem) {
      const path = _http.buildPath(_basePath, _valueListPath);
      const response = await _http.post(path, {
        params: ValueListParamsMapper(valueListItem)
      });
      return _http.toText(response);
    },

    async deleteValueList(label: string) {
      const path = _http.buildPath(
        _basePath,
        _valueListPath,
        _labelsPath,
        label
      );
      const response = await _http.remove(path);
      return _http.toText(response);
    },

    async deleteValue(valueListItemId: number) {
      const path = _http.buildPath(
        _basePath,
        _valueListPath,
        valueListItemId.toString()
      );
      const response = await _http.remove(path);
      return _http.toText(response);
    }
  };
};

export default ValueListService;
